<template>
  <div class="remote-readiness-all">
    <div class="d-flex justify-content-between mb-3 align-items-center">
      <div class="remote-readiness-all__title">All employee</div>
      <search-filter v-on:filter="applyFilter"></search-filter>
    </div>
    <div>
      <remote-readiness-item v-for="staff in staffs" :key="staff.id" :staff="staff"></remote-readiness-item>
    </div>
    <div class="text-center" v-if="staffs.length < pagination.totalItem">
      <button class="btn btn-link font-weight-bold text-accent p-0" @click="getStaffs()">Show more</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      staffs: [],
      pagination: {
        page: 0,
        totalItem: 0
      },
      filter: {
        term: ""
      }
    };
  },

  methods: {
    async getStaffs() {
      this.pagination.page += 1;
      const res = await axios.get(
          `/team-members?status=active&q=${this.filter.term}&page=${this.pagination.page}`
      );
      this.staffs = [...this.staffs, ...res.data.data];
      this.pagination.page = res.data.current_page;
      this.pagination.totalItem = res.data.total;
    },

    applyFilter(filter) {
      this.filter = filter;
      this.staffs = [];
      this.pagination.page = 0;
      this.pagination.totalItem = 0;
      this.getStaffs();
    }
  },

  mounted() {
    this.getStaffs();
  }
};
</script>

<style scoped lang="scss">
.remote-readiness-all {
  &__title {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;

    @media (max-width: 768px) {
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
}
</style>
